import constants from './constants.js'
import ApiClient from './apiClient'

class ApiService {
  constructor (config) {
    this.http = new ApiClient(config)
  }

  /**
   * @returns {Promise<AxiosResponse<T>>}
   */
  getServices () {
    return this.http.get('services')
  }

  /**
   * @param {String} module
   * @param {Object} params
   * @returns {Promise<AxiosResponse<T>>}
   */
  getManager (module, params = {}) {
    return this.http.get('manager', {
      params: {
        module,
        ...params
      }
    })
  }

  /**
   * @param {String} type
   * @param {Number} page
   * @param {Number} perPage
   * @param {String} sectionId
   * @returns {Promise<AxiosResponse<T>>}
   */
  getPublications (type, page, perPage, sectionId) {
    return this.http.get('' + type, {
      params: {
        page,
        perPage,
        sectionId: sectionId || undefined
      }
    })
  }

  /**
   * @param {String} type
   * @param {Number} id
   * @returns {Promise<AxiosResponse<T>>}
   */
  getPublicationsDetail (type, id) {
    return this.http.get('' + type + '/' + id)
  }

  /**
   * @returns {Promise<AxiosResponse<T>>}
   */
  getArticlesSections () {
    return this.http.get('articles_sections')
  }

  /**
   * @param {Number} id
   * @returns {Promise<AxiosResponse<T>>}
   */
  getStock (id) {
    return this.http.get(constants.STOCKS_URL + '/' + id)
  }

  /**
   * @returns {Promise<AxiosResponse<T>>}
   */
  getImpersonationMe () {
    return this.http.get('impersonation/me')
  }

  /**
   * @returns {Promise<AxiosResponse<T>>}
   */
  getImpersonationClients () {
    return this.http.get('impersonation/clients')
  }
}

export default new ApiService({
  responseType: 'json',
  baseURL: '/api/'
})
